import { StateCreator } from 'zustand';
import { allSlices, pollSlice } from './interface';
import { poll } from '@/utils/interface';

const createPollSlice: StateCreator<allSlices, [], [], pollSlice> = (set) => ({
  setPolls: (polls) =>
    set((state) => ({
      poll: {
        ...state.poll,
        polls
      }
    })),
  editOrAddPoll: (updatedPoll) =>
    set((state) => {
      const polls = JSON.parse(JSON.stringify(state.poll?.polls || [])) as poll[];

      const pollIndex = polls.findIndex((poll) => poll._id === updatedPoll._id);
      polls[pollIndex] = updatedPoll;
      if (pollIndex > -1) {
        return {
          poll: {
            ...state.poll,
            polls
          }
        };
      }
      return {
        poll: {
          ...state.poll,
          polls: [...polls, updatedPoll]
        }
      };
    }),
  setViewStatus: (id, status) =>
    set((state) => {
      const polls = JSON.parse(JSON.stringify(state.poll?.polls || [])) as poll[];
      const pollIndex = polls.findIndex((poll) => poll._id === id);
      if (pollIndex > -1 && polls[pollIndex].status !== status) {
        polls[pollIndex] = { ...polls[pollIndex], status };
        return { poll: { ...state.poll, polls } };
      }
      return state;
    }),
  addResponse: (id, response) => {
    set((state) => {
      const polls = JSON.parse(JSON.stringify(state.poll?.polls || [])) as poll[];
      const pollIndex = polls.findIndex((p) => p._id === id);

      if (pollIndex === -1) return state;

      polls[pollIndex].responses = [...(polls[pollIndex].responses || []), response];
      return { poll: { ...state.poll, polls: polls } };
    });
  },
  addResponses: (id, data) => {
    set((state) => {
      const polls = JSON.parse(JSON.stringify(state.poll?.polls || [])) as poll[];
      const pollIndex = polls.findIndex((p) => p._id === id);

      if (pollIndex === -1) return state;

      polls[pollIndex].responses = data;

      return { poll: { ...state.poll, polls: polls } };
    });
  }
});

export default createPollSlice;
